module.exports = __webpack_public_path__ + "static/map.26505245.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/map.png
// module id = 437
// module chunks = 222457311475995